var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.data),function(dat,index){return _c('CallsPerCampaignPenitrationByUser',{key:index,attrs:{"user":dat}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }